<script>
import { Navigation, Pagination, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/svelte';
import {fade} from 'svelte/transition'
import {push, pop, replace} from 'svelte-spa-router'
import {Button, Form, TextInput, Select, SelectItem, Checkbox, DatePicker, DatePickerInput} from 'carbon-components-svelte';
import OtpInput from 'svelte-otp'
import {getUserData} from '../userdata.js'

import {Motion, M} from 'svelte-motion'
import { getAuth, signInWithPhoneNumber, RecaptchaVerifier } from "firebase/auth";
import {itemB} from './animations.js'
import Tailwindcss from '../Tailwind.svelte'
import {animateScroll} from 'svelte-scrollto-element'
import { registerUser } from '../auth';
import {_} from 'svelte-i18n'
import {getCountries}  from '../userdata'
import {auth} from '../firebase.js'
/* import {itemB} from './animations' */
import {sessionData} from '../stores'
import { onMount } from 'svelte';

import TelInput, { normalizedCountries } from 'svelte-tel-input';

  import {signInWithGoogle} from '../auth'
// Any Country Code Alpha-2 (ISO 3166)


/* export let variants */
/* export let container */
/* export let animate */
/* export let trigger */



/* $: ten_sel = selection == '10' ? "selected" : (selection == '30' ? "deselected_left" : "deselected") */
/* $: ten_sel = selection == '10' ? "selected" : (selection == '30' ? "deselected" : "deselected_left") */
/* $: twofive_sel = selection == 'twofive' ? "selected" : "deselected" */
/* $: twofive_sel = selection == '25' ? "selected" : (selection == '10' ? "deselected_right" : "deselected") */
/* $: thirty_sel = selection == '30' ? "selected" : (selection == '10' ? "deselected_middle" : "deselected_right") */


$: one_sel = selection == '1' ? "selected" : "deselected"
$: two_sel = selection == '2' ? "selected" : "deselected"
$: three_sel = selection == '3' ? "selected" : "deselected"
$: five_sel = selection == '5' ? "selected" : "deselected"
$: ten_sel = selection == '10' ? "selected" : "deselected"







export let selection = '1'

  function switcher (sel){
    if(available(sel)){
      selection = sel
    }
    }




function available(t_){
    const t = Number(t_)
    const res = $sessionData.guser?.stakes?.options?.find((g) => g.amount === t)
    return res?.enabled
    }


const amount = {
    deselected: {
        scale: 0.5,
        opacity: 0.5,
        /* x: 43, */
        y: 0

      },


    hovered: {
        scale: 0.65,
        opacity: 0.7,

        /* x: 0, */
        y: 0,

      },


    selected: {
        scale: 1,
        opacity: 1,

        /* x: 0, */
        y: 15,

      },

  }



const amounts = {

    '1': {
        x: 0
      },

    '2': {
        x: 0
      },
    '3': {
        x: 0
      },

    '5': {
        x: 0
      },

    '10': {
        x: 0
      },
  }

  onMount(() => {
    })

</script>


<Tailwindcss/>
{#if $sessionData.selectedCard === 'puzzle'}
  <M.div animate={selection} initial="1" variants={amounts} class="select-none flex flex-row">
    <M.h1 variants={amount} initial="selected" animate={one_sel} whileTap={() => switcher('1')} class="cursor-pointer font-autoscape text-xl6">$1</M.h1>
  </M.div>
{:else}
  <M.div animate={selection} initial="1" variants={amounts} class="select-none flex flex-row gap-x-8">
    <M.h1 variants={amount} initial="selected" animate={one_sel} whileTap={() => switcher('1')} class="cursor-pointer font-autoscape text-xl6">$1</M.h1>
    <M.h1 variants={amount} initial="deselected" animate={two_sel} class="cursor-pointer select-none font-autoscape text-xl8" whileTap={() => switcher('2')}>$2</M.h1>
    <M.h1 variants={amount} initial="deselected" animate={three_sel} whileTap={() => switcher('3')} class="cursor-pointer font-autoscape text-xl8 ">$3</M.h1>
    <M.h1 variants={amount} initial="deselected" animate={five_sel} whileTap={() => switcher('5')} class="cursor-pointer font-autoscape text-xl8 ">$5</M.h1>
    <M.h1 variants={amount} initial="deselected" animate={ten_sel} whileTap={() => switcher('10')} class="cursor-pointer font-autoscape text-xl8 ">$10</M.h1>
  </M.div>
{/if}

<style>
</style>
